import { render } from "./GetEmail.vue?vue&type=template&id=43b10b4f&scoped=true"
import script from "./GetEmail.vue?vue&type=script&lang=js"
export * from "./GetEmail.vue?vue&type=script&lang=js"

import "./GetEmail.vue?vue&type=style&index=0&id=43b10b4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b10b4f"]])

export default __exports__